module.exports = {"title":"Print Star tickets","description":"Make sure this is the correct printer IP Address before printing.","ip":"IP Address:","print":"Print","cancel":"Cancel"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/AlertModalStar/locales/en.json
// module id = 1060
// module chunks = 0